import * as React from "react";
import { Form } from "react-final-form";
import { FieldArray } from "react-final-form-arrays";
import arrayMutator from "final-form-arrays";
import Field from "../../SettingsForm/Field/Field";
import Button from "../../Button/Button";
import "./BookForm.css";
import CloseIcon from "@material-ui/icons/Close";
import { useSelector } from "react-redux";
import { getUserProfile } from "../../../store/user/selectors";
import { useMediaQuery } from "react-responsive";
import { MOBILE_MAX_WIDTH, API_URL } from "../../../utils";

enum Status {
	Ready,
	Wait,
	Done,
	Error
}

const BookForm: React.FC = (props) => {
	const user = useSelector(getUserProfile);
	const [status, setStatus] = React.useState<Status>(Status.Ready);

	const request = async (values: any) => {
		const headers = new Headers();

		headers.append("Content-Type", "application/json;charset=utf-8");

		try {
			const request = await fetch(`${API_URL}/books/form`, {
				method: 'POST',
				body: JSON.stringify({
					form: values
				}),
				credentials: 'include',
				headers
			});

			const data = await request.json();

			return data === true ? undefined : "Ошибка при отправке формы";
		}
		catch (e) {
			return "Ошибка при отправке формы";
		}
	};

	const initialValues = {
		books: [
			{
				bookName: "",
				bookAuthor: "",
			},
		] as any,
		email: user?.email
	};

	const submit = (values: any) => {
		return request(values);
	}

	const isMobile = useMediaQuery({ maxWidth: MOBILE_MAX_WIDTH });

	return (
		<div className="bookForm__container">
			<div className="bookForm">
				<Form
					mutators={{
						...arrayMutator,
					}}
					initialValues={initialValues}
					onSubmit={submit}
				>
					{({ form, handleSubmit }) => {
						return (
							<form>
								<FieldArray name="books">
									{({ fields }) => {
										const remove = (index: number) => {
											fields.remove(index);
										};

										return fields.map((name, index) => {
											return (
												<div className="bookForm__group">
													<div className="bookForm__fields">
														<Field
															name={`${name}.bookName`}
															type="text"
															label="Название книги"
														/>

														<Field
															name={`${name}.bookAuthor`}
															type="text"
															label="Автор"
														/>

														{index > 0 && isMobile && (
															<Button
																className="bookForm__delete_mobile"
																onClick={() => remove(index)}
															>
																Удалить
															</Button>
														)}
													</div>

													{index > 0 && !isMobile && (
														<div
															className="bookForm__delete"
															onClick={() => remove(index)}
														>
															<CloseIcon />
														</div>
													)}
												</div>
											);
										});
									}}
								</FieldArray>

								<div className="bookForm__button">
									<Button
										onClick={() =>
											form.mutators.push("books", {
												bookName: "",
												bookAuthor: "",
											})
										}
									>
										Добавить еще книгу
									</Button>
								</div>

								<div className="bookForm__email">
									<Field name="email" type="text" label="Email" />

									<div className="bookForm__caption">
										На этот email мы пришлем вам ссылки на добавленные книги
									</div>
								</div>

								{form.getState().submitSucceeded &&
									(
										<div className="bookForm__success">
											Спасибо! Мы добавим книги в ближайшие дни и ответим вам
										</div>
									)}

								{form.getState().submitFailed && (
										<div className="bookForm__success bookForm__error">
											Извините, произошла ошибка при отправке. Повторите попытку позже
										</div>
									)}

								<Button
									type="primary"
									isLoading={form.getState().submitting}
									className="bookForm__send"
									onClick={handleSubmit}
								>
									Отправить
								</Button>
							</form>
						);
					}}
				</Form>
			</div>
		</div>
	);
};

export default BookForm;
